import { Autocomplete } from "@mantine/core";
import { CloseX } from "@/common-ui/assets/icon/CloseX";
import type { ContactGroup } from "@/shared-types";

interface NameInputProps {
    value: string;
    onChange: (name: string) => void;
    contacts: ContactGroup[];
}

export function NameInput({ value, onChange, contacts }: NameInputProps) {
    return (
        <Autocomplete
            value={value}
            data={contacts}
            size="sm"
            radius="xs"
            maw="30rem"
            mb="xs"
            autoFocus
            onChange={onChange}
            onOptionSubmit={onChange}
            rightSection={value.length ? <CloseX strokeWidth={"0.1"} data-testid="clear-input" /> : null}
            rightSectionPointerEvents="auto"
            rightSectionProps={{ onClick: () => onChange(""), title: "Clear", className: "cursor-pointer" }}
            data-testid="nameInput"
            placeholder="Search for an extension"
        />
    );
}
